import { GEOMETRY_TYPES, TOOL_EVENT_TYPES } from '../constants';
import type { SketchEvent, ToolEventInfo, GraphicsLayer } from '../types';

/**
 * It was just long and ugly, so I added extracted it to a separate file.
 * Determines whether distance labels should be created for a sketch event.
 *
 * Validates that all required conditions are met for creating distance labels
 * on polyline segments during vertex addition events.
 *
 * @param event - The sketch event to validate
 * @param graphicsLayer - The graphics layer where labels will be added
 * @returns True if distance labels should be created, false otherwise
 *
 * @remarks
 * Checks for the following conditions:
 * - Tool type is polyline
 * - Event has valid tool event info
 * - Tool event type is vertex-add
 * - Event has a valid graphic
 * - Graphics layer is available
 */
export const shouldCreateDistanceLabels = (
  event: SketchEvent,
  graphicsLayer: GraphicsLayer,
): boolean => {
  return Boolean(
    event.tool === GEOMETRY_TYPES.POLYLINE &&
      event.toolEventInfo &&
      typeof event.toolEventInfo === 'object' &&
      'type' in event.toolEventInfo &&
      (event.toolEventInfo as ToolEventInfo).type ===
        TOOL_EVENT_TYPES.VERTEX_ADD &&
      event.graphic &&
      graphicsLayer,
  );
};
